'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionGroup = exports.DrawerButtonGroup = exports.Close = exports.DrawerAction = exports.Background = exports.DrawerContent = exports.BottomDrawer = exports.RightDrawerContainer = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  0% {\n    opacity: 0;\n    transform: scale(.95);\n  }\n\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n'], ['\n  0% {\n    opacity: 0;\n    transform: scale(.95);\n  }\n\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: fixed;\n  width: ', 'px;\n  right: ', ';\n  top: 0;\n  bottom: 0;\n  ', '\n  z-index: 1300;\n  background: #f7f7f7;\n  background: ', ';\n  ', '\n\n  ', '\n\n  @media (max-width: ', 'px) {\n    width: 100%;\n    right: ', ';\n  }\n'], ['\n  position: fixed;\n  width: ', 'px;\n  right: ', ';\n  top: 0;\n  bottom: 0;\n  ', '\n  z-index: 1300;\n  background: #f7f7f7;\n  background: ', ';\n  ', '\n\n  ', '\n\n  @media (max-width: ', 'px) {\n    width: 100%;\n    right: ', ';\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  position: fixed;\n  height: ', 'px;\n  width: 100%;\n  left: 0px;\n  bottom: ', 'px;\n  ', '\n  z-index: 1300;\n  background: #f7f7f7;\n  background: ', ';\n\n  ', '\n'], ['\n  position: fixed;\n  height: ', 'px;\n  width: 100%;\n  left: 0px;\n  bottom: ', 'px;\n  ', '\n  z-index: 1300;\n  background: #f7f7f7;\n  background: ', ';\n\n  ', '\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n     height: 100%;\n     bottom: ', ';\n  '], ['\n     height: 100%;\n     bottom: ', ';\n  ']),
    _templateObject5 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: ', ';\n  padding: ', ';\n  ', '\n  ', '\n  overflow: auto;\n'], ['\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: ', ';\n  padding: ', ';\n  ', '\n  ', '\n  overflow: auto;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  bottom: 0;\n  opacity: ', ';\n  left: ', ';\n  transition: ', ';\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1200;\n  pointer-events: auto;\n'], ['\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  bottom: 0;\n  opacity: ', ';\n  left: ', ';\n  transition: ', ';\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1200;\n  pointer-events: auto;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  width: ', 'px;\n  bottom: 0;\n  height: 60px;\n  position: absolute;\n  background: #f7f7f7;\n  box-shadow: ', ';\n\n  @media (max-width: ', 'px) {\n    width: 100%;\n  }\n'], ['\n  width: ', 'px;\n  bottom: 0;\n  height: 60px;\n  position: absolute;\n  background: #f7f7f7;\n  box-shadow: ', ';\n\n  @media (max-width: ', 'px) {\n    width: 100%;\n  }\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  position: ', ';\n  top: 20px;\n  right: 20px;\n  z-index: 100;\n  cursor: pointer;\n  padding: 0;\n  border: 0;\n  outline: 0;\n  background: none;\n  color: ', ';\n  opacity: 0.9;\n  backface-visibility: hidden;\n  transition-property: color, opacity, transform;\n  transition-duration: .3s;\n\n  &:hover {\n    color: ', ';\n    opacity: 1;\n    transform: scale(1.1);\n  }\n\n  .icon {\n    fill: currentColor;\n    transition: .3s ease-out;\n  }\n'], ['\n  position: ', ';\n  top: 20px;\n  right: 20px;\n  z-index: 100;\n  cursor: pointer;\n  padding: 0;\n  border: 0;\n  outline: 0;\n  background: none;\n  color: ', ';\n  opacity: 0.9;\n  backface-visibility: hidden;\n  transition-property: color, opacity, transform;\n  transition-duration: .3s;\n\n  &:hover {\n    color: ', ';\n    opacity: 1;\n    transform: scale(1.1);\n  }\n\n  .icon {\n    fill: currentColor;\n    transition: .3s ease-out;\n  }\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  padding: 10px 20px 0 20px;\n'], ['\n  padding: 10px 20px 0 20px;\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n  margin-left: auto;\n'], ['\n  margin-left: auto;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _helpers = require('../../helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var fullScreenTransitionIn = (0, _styledComponents.keyframes)(_templateObject);

var RightDrawerContainer = exports.RightDrawerContainer = _styledComponents2.default.div(_templateObject2, function (props) {
  return props.width;
}, function (props) {
  return props.open ? 0 : props.fullWidth ? "-100%" : -props.width + 'px';
}, (0, _helpers.boolStyle)('transition', 'transition: right 500ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;'), function (props) {
  return props.theme.color[props.variant];
}, (0, _helpers.boolStyle)('fullWidth', 'width: 100%;'), function (props) {
  return props.open && props.fullWidth && '\n    opacity: 0;\n    animation-name: ' + fullScreenTransitionIn + ';\n    animation-duration: .6s;\n    animation-fill-mode: forwards;\n    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n    will-change: opacity, transform;\n  ';
}, function (props) {
  return props.width;
}, function (props) {
  return props.open ? "0" : "-100%";
});

RightDrawerContainer.displayName = 'RightDrawerContainer';
var BottomDrawer = exports.BottomDrawer = _styledComponents2.default.div(_templateObject3, function (props) {
  return props.height;
}, function (props) {
  return props.open ? 0 : -props.height;
}, (0, _helpers.boolStyle)('transition', 'transition: bottom 500ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;'), function (props) {
  return props.theme.color[props.variant];
}, _helpers.media.mobileTablet(_templateObject4, function (props) {
  return props.open ? "0" : "-100%";
}));

BottomDrawer.displayName = 'BottomDrawer';
var DrawerContent = exports.DrawerContent = _styledComponents2.default.section(_templateObject5, function (props) {
  return props.staticFooter ? "60px" : "0";
}, function (props) {
  return props.padding;
}, (0, _helpers.boolStyle)("staticFooter", "padding-bottom: 20px;"), (0, _helpers.boolStyle)("actionFooter", "bottom: 50px; padding-bottom: 20px;"));

DrawerContent.displayName = 'DrawerContent';
var Background = exports.Background = _styledComponents2.default.div(_templateObject6, function (props) {
  return props.open ? 1 : 0;
}, function (props) {
  return props.open ? '0' : '100%';
}, function (props) {
  return props.open ? 'left 0ms 0ms, opacity 500ms cubic-bezier(0.4,0,0.2,1) 0ms' : 'left 0ms 500ms, opacity 500ms cubic-bezier(0.4,0,0.2,1) 0ms';
});

Background.displayName = 'Background';
var DrawerAction = exports.DrawerAction = _styledComponents2.default.div(_templateObject7, function (props) {
  return props.width;
}, function (props) {
  return props.open && "0 -2px 4px 0 rgba(0,0,0,0.1)";
}, function (props) {
  return props.width;
});

DrawerAction.displayName = 'DrawerAction';
var Close = exports.Close = _styledComponents2.default.button(_templateObject8, function (props) {
  return props.fixed ? 'fixed' : 'absolute';
}, function (props) {
  return props.theme.color[props.variant];
}, function (props) {
  return props.theme.color[props.variant];
});

Close.displayName = 'Close';
var DrawerButtonGroup = exports.DrawerButtonGroup = _styledComponents2.default.div(_templateObject9);

DrawerButtonGroup.displayName = 'DrawerButtonGroup';
var ActionGroup = exports.ActionGroup = _styledComponents2.default.div(_templateObject10);
ActionGroup.displayName = 'ActionGroup';


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-drawer/styles.js
// module id = 2906
// module chunks = 4